import script from "./UserProfileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileMenu.vue?vue&type=style&index=0&id=4ce2ffb2&lang=scss"

const __exports__ = script;

export default __exports__